import React from 'react';

export interface HeadphonesProps {
  className?: string;
}

const Headphones: React.FC<HeadphonesProps> = ({ className }) => {
  return (
    <svg viewBox="0 0 12 13" fill="none" className={className}>
      <path
        d="M11.3374 8.53298C11.7107 7.73795 11.9061 6.86849 11.9061 5.97489C11.9061 2.6804 9.2566 0 5.99992 0C2.7434 0 0.0938957 2.6804 0.0938957 5.97489C0.0938957 6.86849 0.289305 7.73795 0.662582 8.53298C-0.0298741 9.04402 -0.21037 10.0228 0.267931 10.7523L1.26249 12.2693C1.50075 12.6328 1.86458 12.8805 2.28688 12.9671C2.39482 12.9892 2.50311 13 2.61072 13C2.92455 13 3.23162 12.9071 3.49919 12.7276L4.45173 12.0885C4.64356 11.9597 4.77692 11.7593 4.82251 11.5311C4.86826 11.303 4.82234 11.0659 4.69524 10.8718L2.87592 8.09676C2.7182 7.8563 2.4635 7.72295 2.19916 7.70839C1.95732 7.16701 1.82917 6.57924 1.82917 5.97489C1.82917 3.64833 3.70017 1.7555 5.99992 1.7555C8.29983 1.7555 10.1708 3.64833 10.1708 5.97489C10.1708 6.57924 10.0427 7.16701 9.80086 7.70839C9.5365 7.72294 9.2818 7.8563 9.12408 8.09676L7.30476 10.8718C7.17766 11.0659 7.13174 11.303 7.17749 11.5311C7.22308 11.7593 7.35644 11.9597 7.54827 12.0885L8.50081 12.7276C8.76838 12.9071 9.07528 13 9.38929 13C9.49689 13 9.60518 12.9892 9.71312 12.9671C10.1354 12.8805 10.4992 12.6326 10.7373 12.2693L11.7321 10.7523C12.2104 10.0228 12.0299 9.04401 11.3374 8.53298Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Headphones;
